export function formatCurrency(value) {
  if (typeof value !== 'number') return '—';
  return `$${value.toLocaleString('es-MX', { minimumFractionDigits: 2 })} MXN`;
}

export function formatDate(value) {
  if (!value) return 'Sin fecha';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString('es-MX', {
    dateStyle: 'medium',
    timeStyle: 'short'
  });
}

export function formatFileSize(bytes = 0) {
  if (!bytes && bytes !== 0) return '';
  const kb = bytes / 1024;
  const mb = kb / 1024;
  if (mb >= 1) return `${mb.toFixed(1)} MB`;
  if (kb >= 1) return `${kb.toFixed(1)} KB`;
  return `${bytes} B`;
}
